import * as Optics from "@discovery/sonic-api-ng-optics";
import { Fold, Lens, Traversal } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Just } from "@discovery/prelude/lib/data/maybe";
const _Col2Images = Fold.compose(Optics._Col2Items, Optics._ColItem2Image, Res._Response());
const _ImageByKind = (kind) => Fold.pre(Fold.compose(Fold.mapF((res) => Fold.toArray(_Col2Images, res)), Fold._each(), Traversal._filtered((image) => image.attributes.kind === kind)));
export const _Cards = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, Fold.liftM((title, descriptionM, mobileImageM, desktopImageM, channelImageM) => ({
    title,
    descriptionM,
    mobileImageM,
    desktopImageM,
    channelImageM,
}), Fold.compose(Optics._ColAttributes2Title, _Just()), Fold.compose(Optics._Col2Attributes, Lens.prop("description")), _ImageByKind("default"), _ImageByKind("thumbnail"), _ImageByKind("logo")));

